import * as React from 'react';

import { createIcon } from '../Icon';
export const GridIcon = createIcon(
  <React.Fragment>
    <rect height={7} width={7} x={3} y={3} />
    <rect height={7} width={7} x={14} y={3} />
    <rect height={7} width={7} x={14} y={14} />
    <rect height={7} width={7} x={3} y={14} />
  </React.Fragment>,
  'GridIcon'
);
